<template>
  <div>
    <excise-transactions listObject="bulkContainer" :objectId="bulkContainerId"
                          :activityTypes="[{text:'All',value:''},
                                            {text:'Opening inventory',value:'ExciseVesselTransactionInitial'},
                                            {text:'Transfer site',value:'ExciseVesselTransactionTransferSite'},
                                            {text:'Reduce inventory',value:'ExciseVesselTransactionReduceInventory'},
                                            {text:'Transfer to bulk container',value:'ExciseVesselTransactionTransferToBulkContainer'},
                                            {text:'Transfer to tank',value:'ExciseVesselTransferToTank'},
                                            {text:'Denature',value:'ExciseVesselTransactionDenature'},
                                            {text:'Shipment',value:'Shipment'}
                                          ]"
                          :back="[{text:'Bulk containers',to:{name:'InventoryBulkContainers'}}]"
                          :vessel="false"/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'

export default {
  name: 'InventoryBulkContainersTransactions',
  components: {ExciseTransactions},
  props: {
    bulkContainerId: {type:String, required:true}
  }
}
</script>